export enum NetworkType {
  MainNet,
  TestNet,
  LocalNet,
  SolanaMainnet,
  SolanaTestNet,
  SolanaDevnet,
  SolanaLocalNet,
}
